import { render, staticRenderFns } from "./HomeRightArrow.vue?vue&type=template&id=22f282fd"
import script from "./HomeRightArrow.vue?vue&type=script&lang=js"
export * from "./HomeRightArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports